import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../redux/store';
import { Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export const AuthGate: React.FC<Props> = ({ children }) => {
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // Wrap in a stable container div so React has a consistent DOM node
  // to reconcile against during auth transitions (prevents removeChild errors
  // when Dockview does direct DOM manipulation during mount).
  return <div className="contents">{children}</div>;
};

export default AuthGate;

